import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto,
  GetReadyTemplatesWithPaginationDto,
} from 'src/app/core/api/models';
import { ReadyTemplatesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import {
  BaseIndexModule,
  BaseIndexPageComponent,
} from 'src/app/pages/shared/base';

@Component({
  selector: 'app-ready-templates',
  templateUrl: './ready-templates.component.html',
  imports: [BaseIndexModule],
})
export class ReadyTemplatesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  _sanitizer = inject(DomSanitizer);
  @Input('isModalMode') input_isModalMode = true;
  pageName = PageNames.readyTemplates;
  image: string;

  /* Binding service endpoints */
  protected currentService = inject(ReadyTemplatesService);
  paginationApiMethodName: string =
    this.currentService.readyTemplatesGetReadyTemplatesWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.readyTemplatesCreateGet.name;

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto>;
  items$: Observable<Array<GetReadyTemplatesWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};
  @Output('selectedReadyTemplate') output_selectedReadyTemplate =
    new EventEmitter<GetReadyTemplatesWithPaginationDto>();

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.contentManagement
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.title',
        name: 'title',
        hasSearch: true,
        wrap: true,
      },
      {
        title: 'common.isPublic',
        name: 'isPublicTemplate',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}templatePreview`,
        name: 'templatePreview',
        hasSearch: false,
        noSorting: true,
        type: 'text',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;

    this.currentService
      .readyTemplatesUpdateGet({ ReadyTemplateId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //copy template
  copyReadyTemplateApi(id) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .readyTemplatesCopy({
        body: { readyTemplateId: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;
    this.currentService
      .readyTemplatesDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  copyReadyTemplate(id) {
    this.copyReadyTemplateApi(id);
  }

  onSelect(readyTemplate) {
    this.output_selectedReadyTemplate.emit(readyTemplate);
  }
}
